export default class LocationUtil {
    /**
     * @typedef {{ip: string}} IPResponse
     */

    /**
     * @typedef {{mesasge: string, statusCode: number, data: GeolocationPosition, dataError: GeolocationPositionError}} LocationResponse
     */

    /**
     * @static
     * @return {Promise<{message: string, statusCode: number, data: IPResponse}>} 
     * @memberof LocationUtil
     */
    static async getIP() {
        let response = {
            data: null,
            statusCode: 200,
            message: ""
        }

        try {
            const ipUser = await fetch('https://api.ipify.org?format=json');
            const data = await ipUser.json();
            response = {
                ...response,
                data,
                message: "IP has be gotten sucesfully"
            }
        } catch (error) {
            response = {
                message: "Couldn't get the IP by the service",
                statusCode: -1
            }
        }
        return response
    }

    /**
     *
     * @static
     * @memberof LocationUtil
     * @returns {Promise<LocationResponse>}
     */
    static async getLocation() {
        let response = {
            data: null,
            dataError: null,
            message: "",
            statusCode: 200
        }

        return new Promise((resolve, reject) => {
            if ("geolocation" in navigator) {
                navigator.geolocation.getCurrentPosition((position) => {
                    response = {
                        ...response,
                        data: position,
                        message: "Geolocation gotten succesfully",
                    }
                    resolve(response)
                }, (error) => {
                    response = {
                        dataError: error,
                        message: "There was an error trying to get location",
                        statusCode: -1
                    }
                    reject(response)
                }, {
                    enableHighAccuracy: true
                })
            } else {
                response = {
                    message: "Geolocation is not available in the browser",
                    statusCode: -2
                }
                reject(response)
            }
        }).catch((reason) => reason)
    }
}